














import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ProductTabTypeChange } from '@/models/Product';
import { ProductTabStore } from '@/store/producttabstate';

@Component
export default class OpenProductTab extends Vue {
    constructor() {
        super();
    }

    public setTab(landscape: boolean) {
        const tabTypeChange: ProductTabTypeChange = {
            TabType: '7',
            Scroll: true
        };
        if (landscape) {
            ProductTabStore.setSelectedTabTypeLandscape(tabTypeChange);
        } else {
            ProductTabStore.setSelectedTabTypePortrait(tabTypeChange);
        }
    }
}
